import { withFormik } from "formik";
import * as Yup from "yup";

const formikEnhancer = withFormik({
  validationSchema: Yup.object().shape({
    type: Yup.string()
      .oneOf(
        ["NUMBER_OF_VISIT", "PERCENTAGE"],
        "Type must be either NUMBER OF VISIT or PERCENTAGE"
      )
      .required("Type is required"),
    image: Yup.string()
      .required("Card is required")
      .nullable(),
    stampNotification: Yup.string()
      .required("Notification for stamp is required")
      .nullable(),
    rewardNotification: Yup.string()
      .required("Notification for reward is required")
      .nullable(),
    requiredStamps: Yup.number()
      .min(1, "Minimum 1 stamp required")
      .required("Number of stamp is required")
      .nullable()
  }),
  mapPropsToValues: props => {
    return {
      type: "NUMBER_OF_VISIT",
      image: null,
      stampNotification: null,
      rewardNotification: null
    };
  },
  handleSubmit: values => {},
  displayName: "CustomValidationForm",
  enableReinitialize: true
});

export default formikEnhancer;
